var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorTrading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 564,
    viewBox: "0 0 383 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.407 0H336.593V564H227.407V0Z",
    fill: "#031729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M564 227.407V336.593L0 336.593L4.77265e-06 227.407L564 227.407Z",
    fill: "#031729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442.801 43.9929L520.007 121.199L121.199 520.007L43.9929 442.801L442.801 43.9929Z",
    fill: "#031729"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520.007 442.801L442.801 520.007L43.9929 121.199L121.199 43.9928L520.007 442.801Z",
    fill: "#031729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorTrading);
export default __webpack_public_path__ + "static/media/vector-trading.ec90764897b00f1aebffe4d874b1d7f791cf4589ba32d53ba5567f851882bbc8.svg";
export { ForwardRef as ReactComponent };